/**
 * Enhanced Bundle Builder JavaScript - With Bundle Summary
 */
document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const CONFIG = {
    defaultBundle: { size: 6, free: 2 },
    shippingThreshold: 50,
    baseCardPrice: 6.99,
    animationDuration: 300,
    debounceDelay: 150,
    prefetchDistance: 300,
    filterLoadPages: 10,
    activityInterval: 45000,
    bundleSummaryVariantId: 50106073841959, // Your bundle summary variant ID
    socialProofData: {
      names: [
        'Sarah', 'Mike', 'Emma', 'John', 'Lisa', 'David', 'Amy', 'Chris', 'Jessica', 'Tom', 
        'Alex', 'Hamish', 'Andy', 'Koray', 'Kenny', 'Cooper', 'Dallas', 'Baran', 'Vonni', 'Camellia', 
        'Casey', 'James', 'Sophie', 'Daniel', 'Olivia', 'Matthew', 'Charlotte', 'Jack', 'Mia', 'William',
        'Grace', 'Liam', 'Chloe', 'Joshua', 'Emily', 'Ryan', 'Isabella', 'Luke', 'Zoe', 'Ben',
        'Hannah', 'Nathan', 'Ella', 'Jacob', 'Ruby', 'Ethan', 'Georgia', 'Sam', 'Lily', 'Noah',
        'Amelia', 'Blake', 'Ava', 'Tyler', 'Matilda', 'Jordan', 'Sienna', 'Mitchell', 'Harper', 'Kyle',
        'Jade', 'Lachlan', 'Madison', 'Jayden', 'Scarlett', 'Cameron', 'Jasmine', 'Brodie', 'Tahlia', 'Finn',
        'Kiara', 'Marcus', 'Stephanie', 'Trent', 'Michelle', 'Shane', 'Rebecca', 'Brett', 'Lauren', 'Craig'
      ],
      cities: [
        'Melbourne', 'Sydney', 'Canberra', 'Brisbane', 'Gold Coast', 'Adelaide', 'Hobart', 'Darwin',
        'Perth', 'Newcastle', 'Wollongong', 'Geelong', 'Townsville', 'Cairns', 'Toowoomba', 'Ballarat',
        'Bendigo', 'Albury', 'Launceston', 'Mackay', 'Rockhampton', 'Bunbury', 'Bundaberg', 'Coffs Harbour',
        'Wagga Wagga', 'Hervey Bay', 'Mildura', 'Shepparton', 'Port Macquarie', 'Gladstone', 'Tamworth',
        'Orange', 'Dubbo', 'Geraldton', 'Bathurst', 'Burnie', 'Nowra', 'Warrnambool', 'Alice Springs',
        'Kalgoorlie', 'Mount Gambier', 'Lismore', 'Nelson Bay', 'Maitland', 'Palmerston', 'Goulburn',
        'Whyalla', 'Devonport', 'Murray Bridge', 'Armidale', 'Busselton', 'Port Hedland'
      ],
      recentPurchases: [
        { bundle: '6+2', saved: 13.98 },
        { bundle: '10+4', saved: 27.96 },
        { bundle: '3+1', saved: 6.99 }
      ]
    }
  };
  
  // State management
  const state = {
    selectedBundle: null,
    bundleSize: CONFIG.defaultBundle.size,
    freeItems: CONFIG.defaultBundle.free,
    selectedProducts: [],
    currentFilter: '',
    isLoading: false,
    loadedPages: 1,
    hasMorePages: true,
    bundleCompleteShown: false,
    hasSeenTutorial: false,
    isBundleFull: false,
    activityTimer: null,
    notificationTimeout: null,
    tickerInterval: null,
    showBundleSummary: true // Toggle for showing/hiding bundle summary
  };
  
  // DOM Elements cache
  const elements = {
    // Bundle pills
    bundlePills: document.querySelectorAll('.bundle-pill'),
    bundleTickerText: document.getElementById('bundle-ticker'),
    
    // Cart elements (shared)
    cartItems: document.querySelector('.cart-items'),
    cartSelectedCount: document.querySelector('.cart-selected'),
    cartTotalCount: document.querySelector('.cart-total'),
    checkoutButton: document.querySelector('.cart-checkout'),
    subtotalElement: document.querySelector('.subtotal'),
    freeItemsElement: document.querySelector('.free-items'),
    savingsElement: document.querySelector('.savings-amount'),
    shippingElement: document.querySelector('.shipping'),
    totalElement: document.querySelector('.total-price'),
    clearBundleBtn: document.getElementById('clear-bundle'),
    bonusRow: document.querySelector('.summary-row.bonus-items'),
    bonusText: document.querySelector('.bonus-text'),
    
    // Mobile specific
    mobileBottomBar: document.querySelector('.mobile-bottom-bar'),
    mobileViewBundle: document.querySelector('.mobile-view-bundle'),
    mobileCount: document.querySelector('.mobile-count'),
    mobileTotal: document.querySelector('.mobile-total'),
    mobileCartModal: document.querySelector('.mobile-cart-modal'),
    closeMobileCart: document.querySelector('.close-mobile-cart'),
    mobileCartItems: document.querySelector('.mobile-cart-items'),
    mobileCartSelected: document.querySelector('.mobile-cart-selected'),
    mobileCartTotal: document.querySelector('.mobile-cart-total'),
    mobileCheckout: document.querySelector('.mobile-checkout'),
    mobileTotalPrice: document.querySelector('.mobile-total-price'),
    mobileSavings: document.querySelector('.mobile-savings'),
    mobileShipping: document.querySelector('.mobile-shipping'),
    mobileProgressFill: document.querySelector('.mobile-progress-fill'),
    clearBundleMobile: document.getElementById('clear-bundle-mobile'),
    mobileBonus: document.querySelector('.mobile-bonus'),
    mobileBonusText: document.querySelector('.mobile-bonus-text'),
    
    // Modals
    bundleCompleteModal: document.querySelector('.bundle-complete-modal'),
    completeCount: document.querySelector('.complete-count'),
    completeValue: document.querySelector('.complete-value'),
    completePrice: document.querySelector('.complete-price'),
    completeSavings: document.querySelector('.complete-savings'),
    completeCheckout: document.querySelector('.complete-checkout'),
    completeContinue: document.querySelector('.complete-continue'),
    upgradeSection: document.getElementById('upgrade-section'),
    upgradeButton: document.getElementById('upgrade-button'),
    
    // Filter elements
    filterDropdownTrigger: document.querySelector('.filter-dropdown-trigger'),
    filterDropdownMenu: document.querySelector('.filter-dropdown-menu'),
    filterCurrentText: document.querySelector('.filter-current-text'),
    filterOptions: document.querySelectorAll('.filter-option'),
    mobileFilterButton: document.querySelector('.mobile-filter-button'),
    mobileFilterDropdown: document.querySelector('.mobile-filter-dropdown'),
    mobileFilterOptions: document.querySelectorAll('.mobile-filter-option'),
    
    // Progress elements
    progressBarFill: document.querySelector('.progress-bar-fill'),
    progressCurrentElements: document.querySelectorAll('.progress-current'),
    progressTotalElements: document.querySelectorAll('.progress-total'),
    
    // Other elements
    emptyFilterResults: document.getElementById('empty-filter-results'),
    productsGrid: document.querySelector('.bundle-products-grid'),
    infiniteScrollLoader: document.getElementById('infinite-scroll-loader'),
    paginationContainer: document.getElementById('pagination-container'),
    onboardingOverlay: document.getElementById('onboarding-overlay'),
    onboardingSteps: document.querySelectorAll('.onboarding-step'),
    skipTutorial: document.getElementById('skip-tutorial'),
    body: document.body,
    
    // Social proof
    liveActivity: document.getElementById('live-activity'),
    activityText: document.querySelector('.activity-text'),
    socialCountElements: document.querySelectorAll('.social-count')
  };
  
  // Utility functions
  const utils = {
    debounce(func, delay) {
      let timeoutId;
      return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
      };
    },
    
    throttle(func, limit) {
      let inThrottle;
      return function(...args) {
        if (!inThrottle) {
          func.apply(this, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    },
    
    formatCurrency(amount) {
      return '$' + amount.toFixed(2);
    },
    
    calculatePercentage(saved, total) {
      if (total === 0) return 0;
      return Math.round((saved / total) * 100);
    },
    
    animateValue(element, start, end, duration) {
      if (!element) return;
      const range = end - start;
      const startTime = performance.now();
      
      function updateValue(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const value = start + (range * progress);
        element.textContent = utils.formatCurrency(value);
        
        if (progress < 1) {
          requestAnimationFrame(updateValue);
        }
      }
      
      requestAnimationFrame(updateValue);
    },
    
    animateNumber(element, start, end, duration, suffix = '') {
      if (!element) return;
      const range = end - start;
      const startTime = performance.now();
      
      function updateValue(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const value = Math.round(start + (range * progress));
        element.textContent = value.toLocaleString() + suffix;
        
        if (progress < 1) {
          requestAnimationFrame(updateValue);
        }
      }
      
      requestAnimationFrame(updateValue);
    },
    
    getRandomItem(array) {
      return array[Math.floor(Math.random() * array.length)];
    },
    
    getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  };
  
  // Bundle Pills Functions
  function initBundlePills() {
    const tickerMessages = [
      () => `${utils.getRandomNumber(18, 32)} people building bundles right now`
    ];
    
    // Update ticker
    function updateTicker() {
      if (!elements.bundleTickerText) return;
      
      const newMessage = utils.getRandomItem(tickerMessages)();
      elements.bundleTickerText.style.opacity = '0';
      
      setTimeout(() => {
        elements.bundleTickerText.textContent = newMessage;
        elements.bundleTickerText.style.opacity = '1';
      }, 300);
    }
    
    // Start ticker
    updateTicker();
    state.tickerInterval = setInterval(updateTicker, 8000);
    
    // Update social counts
    function updateSocialCounts() {
      elements.socialCountElements.forEach((count, index) => {
        const baseCount = [893, 2341, 1247][index];
        const variation = utils.getRandomNumber(-50, 50);
        count.textContent = (baseCount + variation).toLocaleString();
      });
    }
    
    updateSocialCounts();
    setInterval(updateSocialCounts, 30000);
    
    // Handle pill clicks
    elements.bundlePills.forEach(pill => {
      pill.addEventListener('click', function() {
        if (this.classList.contains('loading')) return;
        
        // Get bundle data
        const size = parseInt(this.dataset.size);
        const free = parseInt(this.dataset.free);
        
        // Update state
        state.selectedBundle = { size, free, total: size + free };
        state.bundleSize = size;
        state.freeItems = free;
        state.bundleCompleteShown = false;
        state.isBundleFull = state.selectedProducts.length >= state.selectedBundle.total;
        
        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('bundle', `${size}-${free}`);
        window.history.pushState({}, '', url);
        
        // Update UI
        elements.bundlePills.forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        
        // Add loading state briefly
        this.classList.add('loading');
        setTimeout(() => {
          this.classList.remove('loading');
        }, 300);
        
        // Reset button states
        document.querySelectorAll('.add-to-bundle-button-full').forEach(btn => {
          if (btn.classList.contains('added')) {
            btn.textContent = 'Add To Bundle';
            btn.classList.remove('added');
            btn.disabled = false;
          }
        });
        
        // Update the rest of the UI
        updateUI();
        saveBundleState();
        
        // Smooth scroll to products
        setTimeout(() => {
          document.querySelector('.sticky-filter-bar')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
        
        // Show activity notification
        showActivityNotification();
        if (elements.activityText) {
          const bundleNames = {
            '3': 'Starter Sin',
            '6': 'Cardiac Arrest',
            '10': 'Inferno Pack'
          };
          elements.activityText.textContent = `Nice choice! ${bundleNames[size]} selected`;
        }
      });
    });
    
    // Set initial active state
    elements.bundlePills.forEach(pill => {
      const size = parseInt(pill.dataset.size);
      if (size === state.bundleSize) {
        pill.classList.add('active');
      }
    });
  }
  
  // Get bundle name helper
  function getBundleName(size) {
    const bundleNames = {
      3: 'Starter Sin Bundle',
      6: 'Cardiac Arrest Bundle', 
      10: 'Inferno Pack Bundle'
    };
    return bundleNames[size] || `${size}-Card Bundle`;
  }
  
  // Enhanced cart update function for bundle summary
  function updateCartDisplay(container, emptyMessage) {
    if (!container) return;
    
    container.innerHTML = '';
    
    if (state.selectedProducts.length === 0) {
      container.innerHTML = emptyMessage;
    } else {
      const fragment = document.createDocumentFragment();
      
      if (state.showBundleSummary) {
        // Create bundle summary container
        const bundleSummary = createBundleSummaryElement();
        fragment.appendChild(bundleSummary);
        
        // Add bundle items under the summary
        const bundleItemsContainer = document.createElement('div');
        bundleItemsContainer.className = 'bundle-items-container';
        
        state.selectedProducts.forEach((product, index) => {
          const isPaid = index < state.bundleSize;
          const cartItem = createBundleCartItem(product, index, isPaid);
          bundleItemsContainer.appendChild(cartItem);
        });
        
        fragment.appendChild(bundleItemsContainer);
      } else {
        // Regular display without bundle summary
        state.selectedProducts.forEach((product, index) => {
          const isPaid = index < state.bundleSize;
          const cartItem = createCartItem(product, index, isPaid);
          fragment.appendChild(cartItem);
        });
      }
      
      container.appendChild(fragment);
      
      // Add event listeners for remove buttons
      container.querySelectorAll('.cart-item-remove').forEach(btn => {
        btn.addEventListener('click', handleRemoveFromCart);
      });
    }
  }
  
  // Create bundle summary element
  function createBundleSummaryElement() {
    const subtotal = calculateSubtotal();
    const savings = calculateSavings();
    const total = state.selectedBundle.total;
    const current = state.selectedProducts.length;
    
    const div = document.createElement('div');
    div.className = 'bundle-summary-item';
    div.innerHTML = `
      <div class="bundle-summary-header">
        <div class="bundle-summary-icon">📦</div>
        <div class="bundle-summary-details">
          <h3 class="bundle-summary-title">${getBundleName(state.bundleSize)}</h3>
        </div>
      </div>
    `;
    return div;
  }
  
  // Create bundle cart item (nested under summary)
  function createBundleCartItem(product, index, isPaid) {
    const div = document.createElement('div');
    div.className = 'bundle-cart-item';
    div.innerHTML = `
      <img src="${product.image}" alt="${product.title}" class="bundle-item-image">
      <div class="bundle-item-details">
        <h4 class="bundle-item-title">${product.title}</h4>
        <div class="${isPaid ? 'bundle-item-price' : 'bundle-item-free'}">
          ${isPaid ? utils.formatCurrency(product.price) : 'FREE'}
        </div>
      </div>
      <button class="cart-item-remove" data-index="${index}" aria-label="Remove">×</button>
    `;
    return div;
  }
  
  // Create regular cart item
  function createCartItem(product, index, isPaid) {
    const div = document.createElement('div');
    div.className = 'cart-item';
    div.innerHTML = `
      <img src="${product.image}" alt="${product.title}" class="cart-item-image">
      <div class="cart-item-details">
        <h4 class="cart-item-title">${product.title}</h4>
        <div class="${isPaid ? 'cart-item-price' : 'cart-item-free'}">
          ${isPaid ? utils.formatCurrency(product.price) : 'FREE'}
        </div>
      </div>
      <button class="cart-item-remove" data-index="${index}" aria-label="Remove">×</button>
    `;
    return div;
  }
  
  // DRY: Shared progress update
  function updateProgressElement(current, total, fillElement) {
    const percentage = total > 0 ? (current / total) * 100 : 0;
    if (fillElement) {
      fillElement.style.width = `${percentage}%`;
    }
  }
  
  // Social Proof Functions
  function initSocialProof() {
    startActivityNotifications();
    updateMobileTicker();
  }
  
  function startActivityNotifications() {
    setTimeout(showActivityNotification, 5000);
    state.activityTimer = setInterval(showActivityNotification, CONFIG.activityInterval);
  }
  
  function showActivityNotification() {
    if (!elements.liveActivity || !elements.activityText) return;
    
    if (state.notificationTimeout) {
      clearTimeout(state.notificationTimeout);
      elements.liveActivity.classList.remove('show');
    }
    
    const name = utils.getRandomItem(CONFIG.socialProofData.names);
    const city = utils.getRandomItem(CONFIG.socialProofData.cities);
    const purchase = utils.getRandomItem(CONFIG.socialProofData.recentPurchases);
    const message = `${name} from ${city} just saved ${utils.formatCurrency(purchase.saved)} with the ${purchase.bundle} bundle!`;
    
    elements.activityText.textContent = message;
    
    setTimeout(() => {
      elements.liveActivity.classList.add('show');
      
      state.notificationTimeout = setTimeout(() => {
        elements.liveActivity.classList.remove('show');
        state.notificationTimeout = null;
      }, 4000);
    }, 100);
  }
  
  function updateMobileTicker() {
    // Mobile ticker implementation (if needed)
  }
  
  // Initialize
  function init() {
    console.log('Initializing Enhanced Bundle Builder with Bundle Summary');
    
    checkUrlParameters();
    loadBundleState();
    checkTutorial();
    
    if (!state.selectedBundle) {
      state.selectedBundle = {
        size: state.bundleSize,
        free: state.freeItems,
        total: state.bundleSize + state.freeItems
      };
    }
    
    setTimeout(() => {
      document.querySelectorAll('.add-to-bundle-button-full').forEach(btn => {
        btn.classList.remove('added');
        btn.disabled = false;
        if (!btn.classList.contains('bundle-full')) {
          btn.textContent = 'Add To Bundle';
        }
      });
    }, 100);
    
    initBundlePills();
    updateUI();
    setupEventListeners();
    setupInfiniteScroll();
    initSocialProof();
    
    console.log('Bundle Builder initialized successfully');
  }
  
  // Event listeners
  function setupEventListeners() {
    try {
      // Product grid delegation
      elements.productsGrid?.addEventListener('click', function(e) {
        try {
          const button = e.target.closest('.add-to-bundle-button-full');
          if (button && !button.disabled && !button.classList.contains('bundle-full') && !button.classList.contains('added')) {
            e.preventDefault();
            e.stopPropagation();
            handleAddToBundle.call(button, e);
          }
        } catch (error) {
          console.error('Error handling product click:', error);
        }
      });
      
      // Clear bundle
      elements.clearBundleBtn?.addEventListener('click', clearBundle);
      elements.clearBundleMobile?.addEventListener('click', clearBundle);
      
      // Mobile cart
      let savedScrollPosition = 0;
      
      elements.mobileViewBundle?.addEventListener('click', () => {
        savedScrollPosition = window.pageYOffset;
        elements.mobileCartModal.classList.add('active');
        elements.body.classList.add('modal-open');
      });
      
      elements.closeMobileCart?.addEventListener('click', () => {
        elements.mobileCartModal.classList.remove('active');
        elements.body.classList.remove('modal-open');
        window.scrollTo(0, savedScrollPosition);
      });
      
      elements.mobileCartModal?.addEventListener('click', (e) => {
        if (e.target === elements.mobileCartModal) {
          elements.mobileCartModal.classList.remove('active');
          elements.body.classList.remove('modal-open');
          window.scrollTo(0, savedScrollPosition);
        }
      });
      
      // Checkout
      elements.checkoutButton?.addEventListener('click', handleCheckout);
      elements.mobileCheckout?.addEventListener('click', handleCheckout);
      
      // Bundle complete
      elements.completeCheckout?.addEventListener('click', handleCheckout);
      elements.completeContinue?.addEventListener('click', () => {
        elements.bundleCompleteModal.classList.remove('active');
      });
      
      // Upgrade
      if (elements.upgradeButton) {
        const oldButton = elements.upgradeButton;
        const newButton = oldButton.cloneNode(true);
        oldButton.parentNode.replaceChild(newButton, oldButton);
        
        elements.upgradeButton = document.getElementById('upgrade-button');
        
        elements.upgradeButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          try {
            handleUpgrade();
          } catch (error) {
            console.error('Error handling upgrade:', error);
          }
        });
      }
      
      // Filter dropdown events
      elements.filterDropdownTrigger?.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = elements.filterDropdownMenu.classList.contains('show');
        
        if (isOpen) {
          closeFilterDropdown();
        } else {
          openFilterDropdown();
        }
      });
      
      // Filter options
      elements.filterOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.stopPropagation();
          const filter = this.dataset.filter;
          handleFilterChange(filter || '');
          closeFilterDropdown();
        });
      });
      
      // Mobile filter button
      elements.mobileFilterButton?.addEventListener('click', () => {
        elements.mobileFilterDropdown.classList.toggle('show');
      });
      
      // Mobile filter options
      elements.mobileFilterOptions.forEach(option => {
        option.addEventListener('click', function() {
          const filter = this.dataset.filter;
          handleFilterChange(filter || '');
          elements.mobileFilterDropdown.classList.remove('show');
        });
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.inline-filter-select')) {
          closeFilterDropdown();
        }
        
        // Suggestion chips
        const suggestionChip = e.target.closest('.suggestion-chip');
        if (suggestionChip) {
          const tag = suggestionChip.dataset.suggestedTag;
          if (tag) {
            handleFilterChange(tag);
          }
        }
      });
      
      // Touch events for mobile
      document.addEventListener('touchmove', function(e) {
        if (!elements.body.classList.contains('modal-open')) return;
        
        const target = e.target;
        const scrollableElements = [
          elements.mobileCartItems,
          elements.cartItems,
          elements.productsGrid
        ];
        
        const isScrollable = scrollableElements.some(el => 
          el && (el === target || el.contains(target))
        );
        
        if (!isScrollable) {
          e.preventDefault();
        }
      }, { passive: false });
      
    } catch (error) {
      console.error('Error setting up event listeners:', error);
    }
  }
  
  // Filter dropdown functions
  function openFilterDropdown() {
    elements.filterDropdownMenu.classList.add('show');
    elements.filterDropdownTrigger.classList.add('active');
  }
  
  function closeFilterDropdown() {
    elements.filterDropdownMenu.classList.remove('show');
    elements.filterDropdownTrigger.classList.remove('active');
  }
  
  // Handle filter change
  async function handleFilterChange(tag) {
    state.currentFilter = tag;
    
    // Update text
    const filterText = tag ? tag.charAt(0).toUpperCase() + tag.slice(1).replace(/-/g, ' ') : 'All Cards';
    if (elements.filterCurrentText) {
      elements.filterCurrentText.textContent = filterText;
    }
    
    // Update active states
    elements.filterOptions.forEach(option => {
      option.classList.toggle('active', (option.dataset.filter || '') === tag);
    });
    
    elements.mobileFilterOptions.forEach(option => {
      option.classList.toggle('active', (option.dataset.filter || '') === tag);
    });
    
    // Clean up stuck states
    document.querySelectorAll('.add-to-bundle-button-full.added').forEach(btn => {
      if (btn.textContent !== 'Added!') {
        btn.classList.remove('added');
        btn.disabled = false;
      }
    });
    
    // Apply filter
    const visibleCount = filterProducts();
    
    // Force scroll to top of products
    const scrollToProducts = () => {
      const mainContainer = document.querySelector('.bundle-main-container');
      if (mainContainer) {
        const offset = window.innerWidth <= 768 ? 20 : 40;
        const targetY = mainContainer.offsetTop - offset;
        
        window.scrollTo(0, targetY);
        
        setTimeout(() => {
          window.scrollTo({
            top: targetY,
            behavior: 'smooth'
          });
        }, 50);
      }
    };
    
    setTimeout(scrollToProducts, 200);
    
    // Load more if filtering
    if (tag && state.hasMorePages) {
      elements.infiniteScrollLoader.style.display = 'block';
      await loadAllProductsForFilter();
    }
  }
  
  // Filter products
  function filterProducts() {
    const products = Array.from(elements.productsGrid.querySelectorAll('.product-card'));
    let visibleCount = 0;
    
    products.forEach(card => {
      const tags = card.dataset.productTags?.toLowerCase() || '';
      const title = card.dataset.productTitle?.toLowerCase() || '';
      
      let matchesTag = !state.currentFilter || tags.includes(state.currentFilter.toLowerCase());
      
      if (matchesTag) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });
    
    if (elements.emptyFilterResults) {
      elements.emptyFilterResults.style.display = visibleCount === 0 ? 'block' : 'none';
    }
    
    return visibleCount;
  }
  
  // Handle add to bundle
  function handleAddToBundle(e) {
    e.preventDefault();
    
    if (this.disabled || this.classList.contains('added') || this.classList.contains('bundle-full')) {
      return;
    }
    
    if (state.selectedProducts.length >= state.selectedBundle.total) {
      return;
    }
    
    const productCard = this.closest('.product-card');
    const productData = {
      id: productCard.dataset.productId,
      variantId: parseInt(productCard.dataset.variantId),
      title: productCard.querySelector('.product-title').textContent,
      price: parseFloat(productCard.dataset.productPrice),
      image: productCard.querySelector('.product-image').src
    };
    
    const productToAdd = {
      ...productData,
      uniqueId: `${productData.id}_${Date.now()}_${Math.random()}`
    };
    
    state.selectedProducts.push(productToAdd);
    saveBundleState();
    
    const button = this;
    button.disabled = true;
    button.textContent = 'Added!';
    button.classList.add('added');
    
    updateUI();
    
    setTimeout(() => {
      button.disabled = false;
      button.classList.remove('added');
      
      if (state.isBundleFull) {
        button.textContent = 'Bundle Full';
        button.classList.add('bundle-full');
      } else {
        button.textContent = 'Add To Bundle';
      }
    }, 1500);
  }
  
  // Update UI - DRY version
  function updateUI() {
    // Update counts
    const total = state.selectedBundle.total;
    const current = state.selectedProducts.length;
    
    // Update all count displays
    [elements.cartTotalCount, elements.mobileCartTotal, ...elements.progressTotalElements].forEach(el => {
      if (el) el.textContent = total;
    });
    
    [elements.cartSelectedCount, elements.mobileCartSelected, ...elements.progressCurrentElements].forEach(el => {
      if (el) el.textContent = current;
    });
    
    if (elements.freeItemsElement) elements.freeItemsElement.textContent = state.freeItems;
    
    // Update progress bars
    updateProgressElement(current, total, elements.progressBarFill);
    updateProgressElement(current, total, elements.mobileProgressFill);
    
    // Update bundle pills
    elements.bundlePills.forEach(pill => {
      const size = parseInt(pill.dataset.size);
      pill.classList.toggle('active', size === state.bundleSize);
    });
    
    state.isBundleFull = state.selectedProducts.length >= state.selectedBundle.total;
    
    updateAddToBundleButtons();
    updateCart();
    updateMobileBottomBar();
    
    document.dispatchEvent(new Event('cartUpdated'));
  }
  
  // Update add to bundle buttons
  function updateAddToBundleButtons() {
    const buttons = document.querySelectorAll('.add-to-bundle-button-full');
    buttons.forEach(button => {
      if (button.textContent === 'Added!' && button.classList.contains('added')) {
        return;
      }
      
      if (button.classList.contains('added')) {
        button.classList.remove('added');
      }
      
      if (state.isBundleFull) {
        button.textContent = 'Bundle Full';
        button.classList.add('bundle-full');
        button.classList.remove('added');
        button.disabled = false;
      } else {
        button.textContent = 'Add To Bundle';
        button.classList.remove('bundle-full', 'added');
        button.disabled = false;
      }
    });
  }
  
  // Update cart - DRY version
  function updateCart() {
    // Desktop empty message
    const desktopEmptyMessage = `
      <div class="empty-cart-message">
        <div class="empty-cart-icon">🛒</div>
        <p>Select cards to build your bundle</p>
      </div>
    `;
    
    // Mobile empty message
    const mobileEmptyMessage = `
      <div class="empty-cart-message">
        <div class="empty-cart-icon">🛒</div>
        <p>Select cards to build your bundle</p>
      </div>
    `;
    
    // Update both carts
    updateCartDisplay(elements.cartItems, desktopEmptyMessage);
    updateCartDisplay(elements.mobileCartItems, mobileEmptyMessage);
    
    updateCartTotals();
    
    // Show/hide clear buttons
    const hasItems = state.selectedProducts.length > 0;
    if (elements.clearBundleBtn) elements.clearBundleBtn.style.display = hasItems ? 'block' : 'none';
    if (elements.clearBundleMobile) elements.clearBundleMobile.style.display = hasItems ? 'block' : 'none';
    
    // Update checkout button states
    const isComplete = state.selectedProducts.length === state.selectedBundle?.total;
    [elements.checkoutButton, elements.mobileCheckout].forEach(btn => {
      if (btn) btn.classList.toggle('disabled', !isComplete);
    });
    
    // Check for bundle completion
    if (isComplete && elements.bundleCompleteModal) {
      showBundleCompleteModal();
    }
  }
  
  // Handle remove from cart
  function handleRemoveFromCart() {
    const index = parseInt(this.dataset.index);
    state.selectedProducts.splice(index, 1);
    state.bundleCompleteShown = false;
    state.isBundleFull = state.selectedProducts.length >= state.selectedBundle.total;
    
    if (!state.isBundleFull) {
      document.querySelectorAll('.add-to-bundle-button-full.bundle-full').forEach(btn => {
        btn.textContent = 'Add To Bundle';
        btn.classList.remove('bundle-full');
        btn.disabled = false;
      });
    }
    
    saveBundleState();
    updateUI();
  }
  
  // Update cart totals - DRY version
  function updateCartTotals() {
    const counts = {
      selected: state.selectedProducts.length,
      total: state.selectedBundle?.total || 0
    };
    
    const totals = {
      subtotal: calculateSubtotal(),
      savings: calculateSavings(),
      shipping: determineShipping(),
      total: 0
    };
    
    totals.total = totals.subtotal + totals.shipping;
    
    const fullPrice = state.selectedProducts.reduce((sum, product) => sum + product.price, 0);
    const percentage = utils.calculatePercentage(totals.savings, fullPrice);
    
    // Update all total displays
    if (elements.subtotalElement) {
      utils.animateValue(elements.subtotalElement, 0, totals.subtotal, 300);
    }
    
    const savingsContainer = document.querySelector('.savings-amount');
    if (savingsContainer) {
      savingsContainer.innerHTML = `${utils.formatCurrency(totals.savings)} <span class="savings-percentage">(${percentage}%)</span>`;
    }
    
    if (elements.shippingElement) {
      elements.shippingElement.textContent = totals.shipping === 0 ? 'FREE' : utils.formatCurrency(totals.shipping);
    }
    
    if (elements.totalElement) {
      utils.animateValue(elements.totalElement, 0, totals.total, 300);
    }
    
    // Mobile totals
    if (elements.mobileTotalPrice) {
      elements.mobileTotalPrice.textContent = utils.formatCurrency(totals.total);
    }
    
    if (elements.mobileSavings) {
      elements.mobileSavings.textContent = `Save ${utils.formatCurrency(totals.savings)} (${percentage}%)`;
    }
    
    if (elements.mobileShipping) {
      elements.mobileShipping.textContent = totals.shipping === 0 ? '+ Free Shipping' : `+ ${utils.formatCurrency(totals.shipping)} shipping`;
    }
    
    if (elements.mobileTotal) {
      elements.mobileTotal.textContent = utils.formatCurrency(totals.total);
    }
    
    updateBonusDisplay();
  }
  
  // Update bonus display
  function updateBonusDisplay() {
    let bonusText = '';
    let showBonus = false;
    
    if (state.bundleSize === 6) {
      bonusText = 'Free Mini Pin Badge';
      showBonus = true;
    } else if (state.bundleSize === 10) {
      bonusText = 'Free Mini Pin Badge + Free Shipping';
      showBonus = true;
    }
    
    if (elements.bonusRow) {
      elements.bonusRow.style.display = showBonus ? 'flex' : 'none';
    }
    if (elements.bonusText) {
      elements.bonusText.textContent = bonusText;
    }
    
    if (elements.mobileBonus) {
      elements.mobileBonus.style.display = showBonus ? 'block' : 'none';
    }
    if (elements.mobileBonusText) {
      elements.mobileBonusText.textContent = `+ ${bonusText}`;
    }
  }
  
  // Calculate functions
  function calculateSubtotal() {
    return state.selectedProducts
      .slice(0, state.bundleSize)
      .reduce((sum, product) => sum + product.price, 0);
  }
  
  function calculateSavings() {
    return state.selectedProducts
      .slice(state.bundleSize)
      .reduce((sum, product) => sum + product.price, 0);
  }
  
  function determineShipping() {
    if (state.bundleSize === 10) return 0;
    const subtotal = calculateSubtotal();
    return subtotal >= CONFIG.shippingThreshold ? 0 : 6.79;
  }
  
  // Update mobile bottom bar
  function updateMobileBottomBar() {
    if (window.innerWidth <= 768 && elements.mobileBottomBar) {
      const shouldShow = state.selectedProducts.length > 0;
      elements.mobileBottomBar.classList.toggle('visible', shouldShow);
      
      if (elements.mobileCount) {
        elements.mobileCount.textContent = `${state.selectedProducts.length}/${state.selectedBundle.total}`;
      }
    }
  }
  
  // Show bundle complete modal
  function showBundleCompleteModal() {
    if (state.bundleCompleteShown) return;
    
    const total = state.selectedBundle.total;
    const value = total * CONFIG.baseCardPrice;
    const price = state.bundleSize * CONFIG.baseCardPrice;
    const savings = value - price;
    const percentage = utils.calculatePercentage(savings, value);
    
    if (elements.completeCount) elements.completeCount.textContent = total;
    if (elements.completeValue) elements.completeValue.textContent = utils.formatCurrency(value);
    if (elements.completePrice) elements.completePrice.textContent = utils.formatCurrency(price);
    if (elements.completeSavings) elements.completeSavings.textContent = `${utils.formatCurrency(savings)} (${percentage}%)`;
    
    const socialText = document.querySelector('.social-text');
    if (socialText) {
      socialText.textContent = "Congrats on being slightly less shit at gift-giving than usual";
    }
    
    if (elements.upgradeSection) {
      if (state.bundleSize === 10) {
        elements.upgradeSection.classList.add('hidden');
      } else {
        elements.upgradeSection.classList.remove('hidden');
      }
    }
    
    createConfetti();
    elements.bundleCompleteModal.classList.add('active');
    state.bundleCompleteShown = true;
    
    document.dispatchEvent(new CustomEvent('bundleComplete', {
      detail: { bundleSize: state.bundleSize, savings: savings }
    }));
  }
  
  // Create confetti
  function createConfetti() {
    const colors = ['#e15b58', '#4CAF50', '#4a90e2', '#ffd700', '#ff69b4'];
    const confettiCount = 30;
    
    for (let i = 0; i < confettiCount; i++) {
      setTimeout(() => {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';
        confetti.style.left = Math.random() * 100 + '%';
        confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animationDelay = Math.random() * 0.5 + 's';
        confetti.style.animationDuration = (Math.random() * 1.5 + 2) + 's';
        
        elements.bundleCompleteModal.appendChild(confetti);
        
        setTimeout(() => confetti.remove(), 3500);
      }, i * 40);
    }
  }
  
  // Enhanced checkout function with bundle summary
  async function handleCheckout() {
    if (this.classList.contains('disabled') || state.isLoading) return;
    
    state.isLoading = true;
    const originalText = this.textContent;
    this.textContent = 'Processing...';
    this.disabled = true;
    
    try {
      // Calculate bundle details
      const bundleId = Date.now();
      const bundleName = getBundleName(state.bundleSize);
      const subtotal = calculateSubtotal();
      const savings = calculateSavings();
      const savingsPercentage = utils.calculatePercentage(savings, subtotal + savings);
      
      // Create items array
      const items = [];
      
      // Add Bundle Summary Item first (if enabled)
      if (state.showBundleSummary) {
        items.push({
          id: CONFIG.bundleSummaryVariantId,
          quantity: 1,
          properties: {
            '_is_bundle_summary': 'true',
            '_bundle_id': bundleId,
            '_bundle_type': `${state.bundleSize}+${state.freeItems}`,
            '_bundle_name': bundleName,
            '_bundle_items_count': state.selectedProducts.length,
            '_bundle_value': (subtotal + savings).toFixed(2),
            '_bundle_price': subtotal.toFixed(2),
            '_bundle_savings': savings.toFixed(2),
            '_bundle_savings_percentage': savingsPercentage + '%',
            '_bundle_contents': state.selectedProducts.map(p => p.title).join(' | '),
            '_bundle_complete': 'true'
          }
        });
      }
      
      // Add actual bundle items
      state.selectedProducts.forEach((product, index) => {
        items.push({
          id: product.variantId,
          quantity: 1,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_type': `${state.bundleSize}+${state.freeItems}`,
            '_bundle_item_position': `${index + 1} of ${state.selectedProducts.length}`,
            '_is_free': index < state.bundleSize ? 'false' : 'true',
            '_unique_id': product.uniqueId,
            '_part_of_bundle': bundleName
          }
        });
      });
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // Analytics tracking
      if (typeof gtag !== 'undefined') {
        gtag('event', 'bundle_checkout', {
          bundle_type: `${state.bundleSize}+${state.freeItems}`,
          bundle_name: bundleName,
          bundle_value: subtotal,
          bundle_savings: savings,
          items_count: state.selectedProducts.length
        });
      }
      
      // Clear state
      localStorage.removeItem('bundleState');
      state.selectedProducts = [];
      state.bundleCompleteShown = false;
      state.isBundleFull = false;
      
      this.textContent = 'Success!';
      
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 500);
      
    } catch (error) {
      console.error('Checkout error:', error);
      
      this.textContent = 'Error - Try Again';
      
      setTimeout(() => {
        this.textContent = originalText;
        this.disabled = false;
      }, 2000);
      
    } finally {
      state.isLoading = false;
    }
  }
  
  // Handle upgrade
  function handleUpgrade() {
    console.log('Upgrading bundle to 10+4');
    
    elements.bundleCompleteModal.classList.remove('active');
    
    const existingProducts = [...state.selectedProducts];
    
    // Find and click the Inferno Pack pill
    const infernoPackPill = document.querySelector('[data-bundle="10-4"]');
    if (infernoPackPill) {
      infernoPackPill.click();
    } else {
      // Fallback if pill not found
      state.selectedBundle = { size: 10, free: 4, total: 14 };
      state.bundleSize = 10;
      state.freeItems = 4;
      state.bundleCompleteShown = false;
      
      state.selectedProducts = existingProducts;
      state.isBundleFull = state.selectedProducts.length >= state.selectedBundle.total;
      
      const url = new URL(window.location);
      url.searchParams.set('bundle', '10-4');
      window.history.pushState({}, '', url);
      
      saveBundleState();
      updateUI();
    }
  }
  
  // Clear bundle
  function clearBundle() {
    if (confirm('Are you sure you want to clear your bundle?')) {
      state.selectedProducts = [];
      state.bundleCompleteShown = false;
      state.isBundleFull = false;
      
      document.querySelectorAll('.add-to-bundle-button-full').forEach(btn => {
        btn.textContent = 'Add To Bundle';
        btn.classList.remove('added', 'bundle-full');
        btn.disabled = false;
      });
      
      saveBundleState();
      updateUI();
    }
  }
  
  // Tutorial functions
  function checkTutorial() {
    const hasSeenTutorial = localStorage.getItem('hasSeenBundleTutorial');
    if (!hasSeenTutorial && elements.onboardingOverlay) {
      showTutorial();
    }
  }
  
  function showTutorial() {
    elements.onboardingOverlay.classList.add('active');
    
    const nextButtons = elements.onboardingOverlay.querySelectorAll('.onboarding-next');
    const finishButton = elements.onboardingOverlay.querySelector('.onboarding-finish');
    const dots = elements.onboardingOverlay.querySelectorAll('.dot');
    
    nextButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const nextStep = this.dataset.next;
        showTutorialStep(parseInt(nextStep));
      });
    });
    
    finishButton?.addEventListener('click', closeTutorial);
    elements.skipTutorial?.addEventListener('click', closeTutorial);
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => showTutorialStep(index + 1));
    });
  }
  
  function showTutorialStep(step) {
    elements.onboardingSteps.forEach(s => s.classList.remove('active'));
    const targetStep = elements.onboardingOverlay.querySelector(`[data-step="${step}"]`);
    if (targetStep) targetStep.classList.add('active');
    
    const dots = elements.onboardingOverlay.querySelectorAll('.dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index + 1 === step);
    });
  }
  
  function closeTutorial() {
    elements.onboardingOverlay.classList.remove('active');
    localStorage.setItem('hasSeenBundleTutorial', 'true');
  }
  
  // URL parameters
  function checkUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const bundleParam = urlParams.get('bundle');
    
    if (bundleParam) {
      const [size, free] = bundleParam.split('-').map(Number);
      if (!isNaN(size) && !isNaN(free)) {
        state.selectedBundle = { size, free, total: size + free };
        state.bundleSize = size;
        state.freeItems = free;
      }
    }
  }
  
  // State persistence
  function saveBundleState() {
    try {
      const bundleState = {
        selectedBundle: state.selectedBundle,
        bundleSize: state.bundleSize,
        freeItems: state.freeItems,
        selectedProducts: state.selectedProducts,
        isBundleFull: state.isBundleFull
      };
      localStorage.setItem('bundleState', JSON.stringify(bundleState));
    } catch (e) {
      console.warn('Could not save bundle state:', e);
    }
  }
  
  function loadBundleState() {
    try {
      const saved = localStorage.getItem('bundleState');
      if (saved) {
        const bundleState = JSON.parse(saved);
        Object.assign(state, bundleState);
      }
    } catch (e) {
      console.warn('Could not load bundle state:', e);
    }
  }
  
  // Infinite scroll
  function setupInfiniteScroll() {
    let loading = false;
    let observer;
    
    const sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.style.height = '1px';
    elements.productsGrid?.appendChild(sentinel);
    
    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading && state.hasMorePages) {
          loadMoreProducts();
        }
      },
      { rootMargin: `${CONFIG.prefetchDistance}px` }
    );
    
    observer.observe(sentinel);
    
    async function loadMoreProducts() {
      if (loading || !state.hasMorePages) return;
      
      const nextPageUrl = document.querySelector('.pagination-next-url')?.getAttribute('href');
      if (!nextPageUrl) {
        state.hasMorePages = false;
        return;
      }
      
      loading = true;
      elements.infiniteScrollLoader.style.display = 'block';
      
      try {
        const response = await fetch(nextPageUrl);
        const html = await response.text();
        
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        const newProducts = tempDiv.querySelectorAll('.product-card');
        const fragment = document.createDocumentFragment();
        
        newProducts.forEach(card => {
          const productId = card.dataset.productId;
          const existingProduct = elements.productsGrid.querySelector(`[data-product-id="${productId}"]`);
          
          if (!existingProduct) {
            const clone = card.cloneNode(true);
            if (state.isBundleFull) {
              const button = clone.querySelector('.add-to-bundle-button-full');
              if (button) {
                button.textContent = 'Bundle Full';
                button.classList.add('bundle-full');
                button.classList.remove('added');
              }
            }
            fragment.appendChild(clone);
          }
        });
        
        elements.productsGrid.insertBefore(fragment, sentinel);
        
        const nextLink = tempDiv.querySelector('.pagination-next-url');
        if (nextLink) {
          document.querySelector('.pagination-next-url')?.setAttribute('href', nextLink.getAttribute('href'));
        } else {
          state.hasMorePages = false;
          document.querySelector('.pagination-next-url')?.remove();
        }
        
        if (state.currentFilter) {
          filterProducts();
        }
        
        state.loadedPages++;
        
      } catch (error) {
        console.error('Error loading products:', error);
        state.hasMorePages = false;
      } finally {
        elements.infiniteScrollLoader.style.display = 'none';
        loading = false;
      }
    }
  }
  
  // Load all products for filter
  async function loadAllProductsForFilter() {
    if (!state.hasMorePages || state.isLoading) return;
    
    let attempts = 0;
    const maxAttempts = CONFIG.filterLoadPages;
    let totalVisibleCount = 0;
    
    while (state.hasMorePages && attempts < maxAttempts) {
      const nextPageUrl = document.querySelector('.pagination-next-url')?.getAttribute('href');
      if (!nextPageUrl) break;
      
      try {
        const response = await fetch(nextPageUrl);
        const html = await response.text();
        
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        const newProducts = tempDiv.querySelectorAll('.product-card');
        const fragment = document.createDocumentFragment();
        const sentinel = document.querySelector('.infinite-scroll-sentinel');
        
        let matchingCount = 0;
        newProducts.forEach(card => {
          const productId = card.dataset.productId;
          const existingProduct = elements.productsGrid.querySelector(`[data-product-id="${productId}"]`);
          
          if (!existingProduct) {
            const clone = card.cloneNode(true);
            const tags = clone.dataset.productTags?.toLowerCase() || '';
            
            if (!state.currentFilter || tags.includes(state.currentFilter.toLowerCase())) {
              matchingCount++;
            }
            
            if (state.isBundleFull) {
              const button = clone.querySelector('.add-to-bundle-button-full');
              if (button) {
                button.textContent = 'Bundle Full';
                button.classList.add('bundle-full');
                button.classList.remove('added');
              }
            }
            
            fragment.appendChild(clone);
          }
        });
        
        totalVisibleCount += matchingCount;
        
        elements.productsGrid.insertBefore(fragment, sentinel);
        
        const nextLink = tempDiv.querySelector('.pagination-next-url');
        if (nextLink) {
          document.querySelector('.pagination-next-url')?.setAttribute('href', nextLink.getAttribute('href'));
        } else {
          state.hasMorePages = false;
          document.querySelector('.pagination-next-url')?.remove();
        }
        
        attempts++;
        
        if (totalVisibleCount >= 24) {
          break;
        }
        
      } catch (error) {
        console.error('Error loading products:', error);
        break;
      }
    }
    
    filterProducts();
    elements.infiniteScrollLoader.style.display = 'none';
  }
  
  // Cleanup
  window.addEventListener('beforeunload', () => {
    if (state.activityTimer) {
      clearInterval(state.activityTimer);
    }
    if (state.notificationTimeout) {
      clearTimeout(state.notificationTimeout);
    }
    if (state.tickerInterval) {
      clearInterval(state.tickerInterval);
    }
  });
  
  // Window resize
  window.addEventListener('resize', utils.debounce(() => {
    updateMobileBottomBar();
    
    if (window.innerWidth > 768) {
      elements.mobileCartModal?.classList.remove('active');
      elements.body.classList.remove('modal-open');
    }
  }, 200));
  
  // Initialize the app
  init();
});